import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataCertificates } from 'store/ducks/Reportings/types';
import { certificateColumnsICTSystemsFunctions } from 'components/Columns/CertificateForICTSystemsFunction';

interface reportDataProps {
  entityName: string;
}

const CertificatesByICTSystemsByFunctions: React.FC<reportDataProps> = ({
  entityName,
}) => {
  const { date, is_additional_displayed, ict_system_by_function } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataCertificates[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      entity_name: entityName,
      ict_system_id: ict_system_by_function,
      date,
    };

    try {
      const fetchedData =
        await reportingOp.fetchCertificatesByICTSystemFunction(params);
      if (fetchedData && Array.isArray(fetchedData.certificates)) {
        const formattedData = fetchedData.certificates.map(
          (dataItem: any, index: number) => ({
            key: index,
            description: dataItem.certificate_description,
            certificate_id: dataItem.certificate_id,
            certificate_registry: dataItem.certificate_registry,
            date_of_certificate_register: dataItem.date_of_certificate_register,
            date_of_issuance: dataItem.date_of_issuance,
            end_date: dataItem.end_date,
            function_id: dataItem.function_id,
            function_name: dataItem.function_name,
            ict_service_description: dataItem.ict_service_description,
            ict_system_name: dataItem.ict_system_name,
            name_of_entity: dataItem.name_of_entity,
            start_date: dataItem.start_date,
            third_party_service_provider_id:
              dataItem.third_party_service_provider_id,
            validity: dataItem.validity,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (ict_system_by_function) {
      fetchData();
    }
  }, [is_additional_displayed, ict_system_by_function]);

  return (
    <>
      <Table
        columns={certificateColumnsICTSystemsFunctions}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default CertificatesByICTSystemsByFunctions;
